import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable, of } from 'rxjs';
import { IExam } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { ExamOperationService } from 'src/app/exam-layout/operations/exam-operation.service';
import { PopoverRef } from '../popover/popover-ref';
import { CandidateOperationService } from 'src/app/candidates-layout/operations/candidate-operation.service';
import { ro, th } from 'date-fns/locale';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExamScheduleOperationsService } from 'src/app/services/exam-schedule-operations.service';
import { OperationStatus } from 'src/app/exam-layout/operationstatus';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { QuestionBankOperationService } from 'src/app/questions-bank/question-bank-operation.service';

@Component({
  selector: 'app-operation-menu',
  templateUrl: './operation-menu.component.html',
  styleUrls: ['./operation-menu.component.scss']
})
export class OperationMenuComponent implements OnInit {
  exam: IExam = null;
  operations = [];
  currentRoute = "";
  enableOps = false;
  opOpen$: Observable<boolean> = of(false);
  constructor(private route: Router, private popoverRef: PopoverRef<OperationMenuComponent>,
    private examService: ExamService, private exOp: ExamOperationService,
    private canOp: CandidateOperationService, private snackBar: MatSnackBar,
    private exSchOps: ExamScheduleOperationsService, private examSchService: ExamScheduleService, public operationStatus: OperationStatus, private qbOp: QuestionBankOperationService) {
  }

  async ngOnInit() {
    this.currentRoute = this.route.routerState.snapshot.url.split('?')[0].split('?')[0];
    //when route changes needs to be updated
    this.route.events.subscribe((e) => {
      this.currentRoute = this.route.routerState.snapshot.url.split('?')[0].split('?')[0];
      if (this.currentRoute == '/exams') {
        this.operations = this.exOp.operationExamList();
      }
      if (/^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute)
        || this.currentRoute.includes(`/exams/${this.examService.selectedExamIds}/schedules/${this.examSchService.selectedIds}`)) {
        this.operations = this.exSchOps.opsList;
      }

      if (this.currentRoute.includes("questions-bank")) {
        this.operations = this.qbOp.operationQuestionBankList();
      }
    });


    switch (this.currentRoute) {
      case '/exams':
        this.operations = this.exOp.operationExamList();
        break;
      case `/exams/${this.examService.selectedExamIds}/schedules`:
        break;
    }

    if (this.currentRoute == '/exams') {
      this.operations = this.exOp.operationExamList();
    }
    if (/^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute)
      || this.currentRoute.includes(`/exams/${this.examService.selectedExamIds}/schedules/${this.examSchService.selectedIds}`)) {
      this.operations = this.exSchOps.opsList;
    }
    if (this.currentRoute == '/candidates' || this.currentRoute.includes('/candidates/view')) {
      this.operations = this.canOp.operationCandidateList();
    }

    if (/^\/?exams\/\d+\/questions(\/.*)?$/.test(this.currentRoute)) {
      this.operations = this.exOp.questionOperationList();
    }
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
    }

    let isFromExamCandidate = window.location.href.includes('exams/0/schedules?examNo');

    if (this.examSchService.selectedSchedules && this.examSchService.selectedSchedules?.length > 0 && isFromExamCandidate) {
      let examId = this.examSchService.selectedSchedules[0].examinationID;
      var exam = await this.examService.getExamById(examId) as IExam;
      this.examService.setSelectedExam([exam]);
    }

    if (this.currentRoute.includes("questions-bank")) {
      this.operations = this.qbOp.operationQuestionBankList();
    }
  }

  async processOp(route: any, origin: any) {

    if (route === 'operations/examschdule/restart' ||
      route === 'operations/examschdule/recomputeissuescore' ||
      route === 'operations/examschdule/addtime' ||
      route === 'operations/examschdule/pauseunpauseexam' ||
      route === 'operations/examschdule/changeStatus' ||
      route === 'operations/examschdule/changeexamschedule' ||
      route === 'operations/examschdule/generatesebconfig' ||
      route === 'operations/examschdule/import_candidates_data' || route === 'operations/examschdule/flags'
      || route === 'operations/examschdule/autoMarkSAQ') {
      this.exSchOps.processOperation(route, origin);
    }
    else if (route.includes("exam")) {
      this.exOp.processExamOperation(route, origin);
    }
    else if (route.includes("candidate")) {
      this.canOp.processCandidateOperation(route, origin);
    }
    else if (route.includes("questions-bank")) {
      this.qbOp.processQuestionBankOperation(route, origin);
    } else if (route.includes("operations/questions/disableEnableQuestions")) {
      this.exOp.processQuestionOperation(route, origin);
    }
    this.popoverRef.close();
  }
}